import {Component, HostBinding} from '@angular/core';
import {ConfigService} from '../../services/config/config.service';

@Component({
  selector: 'xp-not-for-clinical-use',
  templateUrl: './not-for-clinical-use.component.html',
  styleUrl: './not-for-clinical-use.component.scss',
})
export class NotForClinicalUseComponent {

  constructor(
    private readonly _configService: ConfigService,
  ) {
  }

  @HostBinding('class.hidden')
  public get hidden(): boolean {
    return !this._configService.config.notForClinicalUse;
  }

}
